import React, { useState } from "react";
import WhatsAppBulkSender from "./BulkSender/WhatsAppBulkSender";
import ChatList from "./Chatting/ChatList";

const WhatsAppInterface: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"chat" | "bulk">("chat");

  return (
    <div className="flex h-screen ">
      <div className="w-16 bg-gray-200 flex flex-col items-center py-4">
        <button
          onClick={() => setActiveTab("chat")}
          className={`w-12 h-12 rounded-full flex items-center justify-center mb-4 ${
            activeTab === "chat"
              ? "bg-green-500 text-white"
              : "bg-gray-700 text-gray-300 hover:bg-gray-600"
          }`}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
            ></path>
          </svg>
        </button>

        <button
          onClick={() => setActiveTab("bulk")}
          className={`w-12 h-12 rounded-full flex items-center justify-center ${
            activeTab === "bulk"
              ? "bg-green-500 text-white"
              : "bg-gray-700 text-gray-300 hover:bg-gray-600"
          }`}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
            ></path>
          </svg>
        </button>
      </div>

      {/* Main content area */}
      <div className="flex-1 flex overflow-hidden">
        {activeTab === "chat" ? (
          <div className="flex-1">
            <ChatList />
          </div>
        ) : (
          <div className="flex-1 overflow-y-auto flex justify-center">
            <WhatsAppBulkSender />
          </div>
        )}
      </div>
    </div>
  );
};

export default WhatsAppInterface;
